































































// Importing components
import BaseFooter from '@/base/BaseFooter.vue';

export default {
    name: 'PageHelp',
    components: {
        BaseFooter,
    },
    props: {},
    data() {
        return {};
    },
    methods: {},
};
